import React from "react";
import Policy from "components/Policy/Policy";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";

const PolicyPage = () => {
    return (
        <div className='overlay'>
            <Header />
            <Policy />
            <Footer />
        </div>
    );
};

export default PolicyPage;